class UserController {
  constructor(User) {
    this.name = 'user';
    this.User = User;
    User.getUsers().then((users) => {
      this.users = users;
    });
  }
  onSubmit(searchQuery) {
    this.User.getUsers({ searchQuery }).then((users) => {
      this.users = users;
    });
  }
  clearSearch() {
    this.searchUser = '';
    this.User.getUsers().then((users) => {
      this.users = users;
    });
  }
}
UserController.$inject = ['User'];
export default UserController;



// WEBPACK FOOTER //
// ./client/app/components/user/user.controller.js